import { 
	createSlice,
	createSelector,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'

import {
	envAwarePost,
	dateToAPIStandard
} from '../../../util/util'

export const getPayments = createAsyncThunk(
	'getPayments',
	async payload => await envAwarePost(
		'api/financials/',
		{action:'getPayments'}
	)
)

const paymentsAdapter = createEntityAdapter({
	selectId: ent => ent.payment_id
})

export const editPaymentComment = createAsyncThunk(
	'editPaymentComment',
	async payload => await envAwarePost(
		'api/financials/',
		{action:'editPaymentComment',...payload}
	)
)

const slice = createSlice({
	name: 'payments',
	initialState : paymentsAdapter.getInitialState({
		status:'init'
	}),
	reducers : {},
	extraReducers : {
		[getPayments.pending] : (state,action) => { 
			state.status = 'pending' 
		},
		[getPayments.fulfilled] : (state,action) => {
			state.status = 'idle'
			paymentsAdapter.upsertMany(state,action.payload.data.payments)
		},
		[editPaymentComment.pending] : (state,action) => {
			const {id,comment} = action.meta.arg
			paymentsAdapter.updateOne(state,{id,changes:{comment:comment}})
		}
	}
})

export const {
	selectAll: selectAllPayments,
	selectById: selectPaymentById,
	selectIds: selectPaymentIds
} = paymentsAdapter.getSelectors( state => state.payments )

export default slice.reducer